
<input
  type="file"
  #fileInput
  hidden
  [multiple]="multiple"
  [accept]="allowedExtensions.join(',')"
  (change)="onFileSelected($event)" />

<div class="upload-area" appFileDropper (fileDropped)="onFileDropped($event)">
  <mat-icon>cloud_upload</mat-icon>
  <p>Drag and drop document{{ multiple ? 's' : '' }} here ({{ displayExtensions }}), or</p>
  <button type="button" mat-raised-button color="primary" (click)="fileInput.click()">Select File</button>
</div>

@if (selectedFiles.length > 0) {
  <div class="file-list-container">
    <h3>Selected File{{ multiple ? 's' : '' }}:</h3>
    <div class="file-tiles-container">
      @for (file of selectedFiles; track file.name; let i = $index) {
        <div class="file-tile">
          <div class="file-icon-wrapper">
            <mat-icon class="file-icon">insert_drive_file</mat-icon>
          </div>

          <p class="file-name" [title]="file.name">{{ file.name }}</p>

          <button type="button" mat-icon-button class="remove-button" (click)="removeFile(i)">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      }
    </div>
  </div>
}
